import { Server } from "lucide-react";

export const MACHINES_TABLE_CONSTANTS = {
  tableName: "machines",
  className: "Machine",
  // Resolved to a module and class by name in the Celery export task, so it has
  // to stay in sync with api/main/tables/machines_table.py's class name.
  exportTableName: "MachinesTable",
  header: "Machines",
  headerIcon: Server,
};

// The unscoped /machines view predates the merge with the case- and
// entity-scoped tables and keeps its own saved-preferences bucket.
export const COMPLETE_MACHINES_TABLE_NAME = "complete_machines";
